import 'core-js/stable';
import React from 'react';
import 'regenerator-runtime/runtime';
import './assets/js/cookie-yes';

import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import App from './components/App';
import LocalizationWrapper from './localization/LocalizationWrapper';

import './styles/styles.scss';

require('./assets/img/favicon.ico'); // webpack load favicon.ico

const container = document.getElementById('app');
const root = createRoot(container);

// Load store lazily
const bootstrap = async () => {
  const [{ store }, { requestInterceptor, responseInterceptor }] = await Promise.all([
    import(/* webpackChunkName: "Store" */ '@/store/store'),
    import(/* webpackChunkName: "RequestInterceptor" */ './api/requestInterceptor'),
  ]);

  // FIXME: ONLY store requests are intercepted
  requestInterceptor(store);
  responseInterceptor(store);

  root.render(
    <Provider store={store}>
      <LocalizationWrapper>
        <BrowserRouter
          future={{
            v7_startTransition: true,
          }}
        >
          <App />
        </BrowserRouter>
      </LocalizationWrapper>
    </Provider>,
  );
};

bootstrap();
